import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router-dom";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { getDb, packages } from "util/Constants";
import Select from "react-select";
import { getSelectedObject } from "../../util/Helper";
import moment from "moment/moment";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { NotificationManager } from "react-notifications";
import axios from "axios";

export default function Accounts() {
  const [users, setUsers] = useState([]);
  const [fullUsers, setFullUsers] = useState([]);
  const [loading, setLoading] = useState(null);
  const [load, setLoad] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [changeEmailIsOpen, setChangeEmailIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [searchedEmail, setSearchedEmail] = useState("");
  const [searchedCompany, setSearchedCompany] = useState("");
  const [searchedPlan, setSearchedPlan] = useState("");
  const [searchedExpired, setsearcedExpired] = useState("");
  const [maxUsers, setMaxUsers] = useState("");
  const [maxAssessments, setMaxAssessments] = useState("");

  const history = useHistory();

  const options = [
    { value: "free", label: "Free" },
    { value: "standard", label: "Standard" },
    { value: "premium", label: "Premium" },
  ];

  const searchOptions = [
    { value: "default", label: "All" },
    { value: "free", label: "Free" },
    { value: "standard", label: "Standard" },
    { value: "premium", label: "Premium" },
  ];

  const searchExpiry = [
    { value: "all", label: "All" },
    { value: "expired", label: "Expired" },
    // { value: 'nonExpired', label: 'Non-Expired' },
  ];

  useEffect(() => {
    let filteredUsers = fullUsers;

    if (searchedExpired && searchedExpired !== "all") {
      filteredUsers = filteredUsers.filter((user) => {
        const isExpired =
            user?.plan !== "free" &&
            user?.expiry !== null &&
            user?.expiry!==""&&
            user?.expiry < Date.now();
        if (searchedExpired === "expired") {
          return isExpired;
        }
      });
    }

    if (searchedEmail) {
      filteredUsers = filteredUsers.filter((user) =>
          user.email.toLowerCase().includes(searchedEmail.toLowerCase())
      );
    }

    if (searchedCompany) {
      filteredUsers = filteredUsers.filter((user) =>
          user.companyName.toLowerCase().includes(searchedCompany.toLowerCase())
      );
    }

    if (searchedPlan && searchedPlan !== "default") {
      filteredUsers = filteredUsers.filter((user) =>
          user.plan?.toLowerCase().includes(searchedPlan?.toLowerCase())
      );
    }

    setUsers(filteredUsers);
  }, [searchedExpired, searchedEmail, searchedCompany, searchedPlan]);

  // useEffect(()=>{
  //     const temp=[...users];
  //     if(searchedName) {
  //         console.log("inside searchedName")
  //         console.log("temp", temp)
  //         setUsers(temp.filter(user => user.name.toLowerCase().includes(searchedName.toLowerCase())));
  //     }
  //     if(searchedEmail) {
  //         console.log("inside searchedEmail")
  //         console.log("temp", temp)
  //         setUsers(temp.filter(user => user.email.toLowerCase().includes(searchedEmail.toLowerCase())));
  //     }
  //     if(searchedCompany) {
  //         console.log("temp", temp)
  //         console.log("inside searchedCompany")
  //         setUsers(temp.filter(user => user.companyName.toLowerCase().includes(searchedCompany.toLowerCase())));
  //     }
  //     if(searchedPlan) {
  //         console.log("temp", temp)
  //         console.log("inside searchedPlan")
  //         setUsers(temp.filter(user => user.plan.toLowerCase().includes(searchedPlan.toLowerCase())));
  //     }
  //
  //     if (!searchedName && !searchedEmail && !searchedCompany && (!searchedPlan || searchedPlan === "default" )) {
  //         setUsers(fullUsers);
  //     }
  //
  // },[searchedName, searchedEmail, searchedCompany, searchedPlan])

  const sendResetPasswordEmail = async () => {
    setIsLoading(true);
    const { email, id } = selectedUser;
    if (!newEmail) {
      NotificationManager.error("Please enter a new email address");
    }
    if (newEmail === email) {
      NotificationManager.error(
          "Please enter a new email address different from the current one"
      );
    }
    if (newEmail && newEmail !== email) {
      try {
        await axios
            .post(
                "https://ydjsk72zli.execute-api.us-east-1.amazonaws.com/change-email-pepsico",
                {
                  uuid: id,
                  newEmail: newEmail,
                }
            )
            .then((res) => {})
            .catch((err) => {});
        sendPasswordResetEmail(getAuth(), newEmail)
            .then(() => {})
            .catch((err) => {});
        NotificationManager.success("Please check your password reset email");
        setChangeEmailIsOpen(false);
        setNewEmail("");
        await loadUsers();
      } catch (err) {
        NotificationManager.error(err.message);
      }
    }
    setIsLoading(false);
  };

  const plansObject = {
    free: {
      name: userData?.name,
      email: userData?.email,
      maxAssessments: 1,
      maxUsers: 15,
      plan: {
        amount: 0,
      },
      updatedAt: moment().unix(),
    },
    standard: {
      name: userData?.name,
      email: userData?.email,
      maxAssessments: maxAssessments,
      maxUsers: maxUsers,
      plan: {
        amount: 0,
      },
      updatedAt: moment().unix(),
    },
    premium: {
      name: userData?.name,
      email: userData?.email,
      maxAssessments: maxAssessments,
      maxUsers: maxUsers,
      plan: {
        amount: 0,
      },
      updatedAt: moment().unix(),
    },
  };

  useEffect(async () => {
    loadUsers().then(() => {});
  }, []);

  const loadUsers = async () => {
    let arr = [];
    const q = query(
        collection(getDb(), "admins"),
        where("role", "==", "admin")
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      arr.push({ ...doc.data(), id: doc.id });
    });
    setUsers(arr);
    setFullUsers(arr);
    setLoad(false);
  };

  const column = [
    {
      name: "Name",
      // center: true,
      selector: (row) => row.name,
    },
    {
      name: "Email",
      // center: true,
      selector: (row) => row.email,
    },
    {
      name: "Company Name",
      // center: true,
      selector: (row) => row.companyName,
    },

    {
      name: "Users",
      // center: true,
      selector: (row) => row.usersCount,
    },
    {
      name: "Assessments",
      // center: false,
      selector: (row) => row.assessmentsCount,
    },

    {
      name: "Active",
      // center: true,
      // width: "75px",
      selector: (row) => row.active,
      cell: (row) => {
        return (
            <div className="text-center">
              {row.active ? (
                  <>
                    <i className="fas fa-check text-success" />
                    {row.expiry && row.expiry < Date.now() && (
                        <>
                          <span className="mx-1">&#9679;</span>{" "}
                          <span className="text-danger fw-bold">Expired</span>
                        </>
                    )}
                  </>
              ) : (
                  <>
                    <i className="fas fa-times text-danger" />
                    {row.expiry && row.expiry < Date.now() && (
                        <>
                          <span className="mx-1">&#9679;</span>
                          <span className="text-danger fw-bold">Expired</span>
                        </>
                    )}
                  </>
              )}
            </div>
        );
      },
    },
    {
      name: "Package",
      // center: true,
      selector: (row) => row.plan,
    },

    {
      name: "",
      // center: true,
      width: "250px",
      selector: (row) => null,
      cell: (row) => (
          <div className="d-flex justify-content-end w-100">
            <Button
                onClick={() => history.push(`/assessment/dashboard?id=${row.id}`)}
                color="default"
                size="sm"
            >
              <i className="far fa-eye" />
            </Button>
            <Button
                color={row.active ? "danger" : "success"}
                size="sm"
                disabled={loading === `blocking_${row.id}`}
                onClick={async () => {
                  setLoading(`blocking_${row.id}`);
                  await updateDoc(doc(getDb(), "admins", row.id), {
                    active: !row.active,
                  });

                  const index = users.findIndex((obj) => obj.id === row.id);
                  if (index >= 0) {
                    const data = users;
                    data[index].active = !data[index].active;
                    setUsers(data);
                  }
                  setLoading(null);
                }}
            >
              {loading === `blocking_${row.id}` ? (
                  <Spinner className="mx-2" color={"white"} size={"sm"}>
                    Loading...
                  </Spinner>
              ) : row.active ? (
                  <i className="fas fa-ban" />
              ) : (
                  <i className="fas fa-undo" />
              )}
            </Button>
            <Button
                color="primary"
                className={"text-nowrap"}
                size="sm"
                onClick={() => handleUpgrade(row)}
            >
              Upgrade
            </Button>
            <Button
                color="primary"
                className={"text-nowrap"}
                size="sm"
                onClick={() => {
                  setSelectedUser(row);

                  changeEmailToggle();
                }}
            >
              Change Email
            </Button>
          </div>
      ),
    },
  ];

  const handleUpgrade = (user) => {
    console.log(user);
    setUserData(user);
    setMaxUsers(user.maxUsers);
    setMaxAssessments(user.maxAssessments);

    setSelectedPlan(user.plan);
    toggle();
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const changeEmailToggle = () => {
    setChangeEmailIsOpen(!changeEmailIsOpen);
  };

  const saveUserInfo = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const db = getDb();
    console.log(maxAssessments, maxUsers, plansObject, "dataget");
    const userRef = doc(db, "admins", userData?.id);
    // query the docs and get the data where email matches

    try {
      selectedPlan === "free"
          ? await setDoc(doc(db, "payments", userData?.id), plansObject.free)
          : selectedPlan === "standard"
              ? await setDoc(doc(db, "payments", userData?.id), plansObject.standard)
              : await setDoc(doc(db, "payments", userData?.id), plansObject.premium);

      selectedPlan === "free"
          ? await setDoc(userRef, packages.free, { merge: true })
          : selectedPlan === "standard"
              ? await setDoc(
                  userRef,
                  {
                    maxUsers: parseInt(maxUsers),
                    maxAssessments: parseInt(maxAssessments),
                    plan: selectedPlan,
                  },
                  { merge: true }
              )
              : await setDoc(
                  userRef,
                  {
                    maxUsers: parseInt(maxUsers),
                    maxAssessments: parseInt(maxAssessments),
                    plan: selectedPlan,
                  },
                  { merge: true }
              );
    } catch (err) {
      setIsLoading(false);
    }
    // await loadUsers();
    setUsers((prevState) => {
      const index = prevState.findIndex((obj) => obj.id === userData.id);
      if (index >= 0) {
        const data = prevState;
        data[index].plan = selectedPlan;
        data[index].maxAssessments = maxAssessments;
        data[index].maxUsers = maxUsers;
        // if (selectedPlan === "free") {
        //     data[index].usersCount = 50;
        //     data[index].assessmentsCount = 2;
        // }
        // if (selectedPlan === "standard") {
        //     data[index].usersCount = 100;
        //     data[index].assessmentsCount = 5;
        // }
        // if (selectedPlan === "premium") {
        //     data[index].usersCount = 200;
        //     data[index].assessmentsCount = 10;
        // }
        // data[index].usersCount = plansObject[selectedPlan].users;
        // data[index].assessmentsCount = plansObject[selectedPlan].assessments;
        return data;
      }
    });
    setIsLoading(false);
    toggle();
  };

  return (
      <>
        {/* <div className="header pb-8 pt-5 pt-md-8"/> */}
        <Container fluid>
          <Row className={"mt-2"}>
            <Col md={"3"}>
              <div className="form-group">
                <Label>Expiry</Label>
                <Select
                    className=""
                    options={searchExpiry}
                    value={getSelectedObject(searchedExpired, searchExpiry)}
                    onChange={(e) => setsearcedExpired(e.value)}
                />
              </div>
            </Col>

            {/* <Col md={"3"}>
                        <div className="form-group">
                            <Label>Name</Label>
                            <Input
                                className="form-control-alternative"
                                value={searchedName}
                                onChange={(e) => setSearchedName(e.target.value)}
                                placeholder={"Search Name"}
                            />
                        </div>
                    </Col> */}
            <Col md={"3"}>
              <div className="form-group">
                <Label>Email</Label>
                <Input
                    className="form-control-alternative"
                    value={searchedEmail}
                    onChange={(e) => setSearchedEmail(e.target.value)}
                    placeholder={"Search Email"}
                />
              </div>
            </Col>
            <Col md={"3"}>
              <div className="form-group">
                <Label>Company Name</Label>
                <Input
                    value={searchedCompany}
                    className="form-control-alternative"
                    onChange={(e) => setSearchedCompany(e.target.value)}
                    placeholder={"Search Company Name"}
                />
              </div>
            </Col>
            <Col md={"3"}>
              <div className="form-group">
                <Label>Package</Label>
                <Select
                    className=""
                    options={searchOptions}
                    value={getSelectedObject(searchedPlan, searchOptions)}
                    onChange={(e) => setSearchedPlan(e.value)}
                />
              </div>
            </Col>
          </Row>
          <Card>
            <DataTable
                columns={column}
                data={users}
                progressPending={load}
                pagination={true}
            />
          </Card>

          <Modal isOpen={isOpen} toggle={toggle}>
            <Form onSubmit={saveUserInfo}>
              <ModalHeader>Choose a plan</ModalHeader>
              <ModalBody>
                <Row>
                  <Col md={12}>
                    <Label>Choose a Plan</Label>
                    <Select
                        options={options}
                        value={getSelectedObject(selectedPlan, options)}
                        onChange={(e) => setSelectedPlan(e.value)}
                    />
                  </Col>
                  {selectedPlan !== "free" && (
                      <>
                        <Col md={12}>
                          <Label className="mt-1">Max Users</Label>
                          <Input
                              value={maxUsers}
                              type="number"
                              className="form-control-alternative"
                              onChange={(e) => setMaxUsers(e.target.value)}
                              placeholder={"Max Users"}
                              min={1}
                              max={9999}
                              required
                          />
                        </Col>
                        <Col md={12}>
                          <Label className="mt-1 ">Max Assessments</Label>
                          <Input
                              value={maxAssessments}
                              max={999}
                              min={1}
                              required
                              type="number"
                              className="form-control-alternative"
                              onChange={(e) => setMaxAssessments(e.target.value)}
                              placeholder={"Max Assessments"}
                          />
                        </Col>
                      </>
                  )}
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button color={"primary"} type="submit">
                  {isLoading ? <Spinner size={"sm"} color={"white"} /> : "Save"}
                </Button>
                <Button
                    type="button"
                    color={"secondary"}
                    onClick={() => {
                      setSelectedPlan(null);
                      toggle();
                    }}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Form>
          </Modal>

          <Modal isOpen={changeEmailIsOpen} toggle={changeEmailToggle}>
            <ModalHeader>Change Email</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <Label>Current Email</Label>
                  <Input type="email" value={selectedUser?.email} disabled />

                  <Label>Enter New Email</Label>
                  <Input
                      type="email"
                      value={newEmail}
                      placeholder={"Enter New Email"}
                      onChange={(e) => setNewEmail(e.target.value)}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color={"primary"} onClick={sendResetPasswordEmail}>
                {isLoading ? <Spinner size={"sm"} color={"white"} /> : "Change"}
              </Button>
              <Button
                  color={"secondary"}
                  onClick={() => {
                    setNewEmail(null);
                    setSelectedUser(null);
                    changeEmailToggle();
                  }}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </>
  );
}
